import { InjectionToken, StaticProvider } from '@angular/core';

import { BaseApiConfig } from '../../models/base-api-config.model';

export type ProfileApiConfig = BaseApiConfig<{
  getProfile: string;
  updateProfile: string;
}>;

export const PROFILE_API_CONFIG = new InjectionToken<ProfileApiConfig>('PROFILE_API_CONFIG');

export const provideProfileApiConfig = (config: ProfileApiConfig): StaticProvider => ({
  provide: PROFILE_API_CONFIG,
  useValue: config,
});
